import Cookies from 'js-cookie';

/**
 * Identificador curto e estavel do usuario logado, para separar o cache local
 * por PESSOA e nao so por conta (#1293).
 *
 * O motivo: o catalogo de etiquetas deixou de ser o mesmo para todo mundo na
 * conta — etiqueta privada aparece para o autor, para o administrador e para
 * quem tem `label_private_view`, e some para os demais. O IndexedDB e por
 * navegador: sem separar, quem entrasse depois no mesmo navegador leria a lista
 * cacheada de quem entrou antes.
 *
 * O `uid` (o e-mail) sai do cookie de sessao, que ja existe e e sincrono — o
 * store do Vuex nao serve aqui porque o `DataManager` roda em `api/*.js`, fora
 * do ciclo de vida da aplicacao. Ele e reduzido a um hash djb2 em base36: o nome
 * do banco fica curto e o e-mail nao vira nome de banco visivel no DevTools.
 *
 * Sem cookie (logout, aba anonima, cookie bloqueado) devolve `anon` — o cache
 * ainda funciona, so nao e compartilhado com nenhuma sessao logada.
 */

const AUTH_COOKIE = 'cw_d_session_info';

const djb2 = value => {
  let hash = 5381;
  for (let i = 0; i < value.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = ((hash << 5) + hash + value.charCodeAt(i)) >>> 0;
  }
  return hash.toString(36);
};

export const userCacheScope = () => {
  try {
    const raw = Cookies.get(AUTH_COOKIE);
    if (!raw) return 'anon';

    const { uid } = JSON.parse(raw) || {};
    return uid ? `u${djb2(String(uid))}` : 'anon';
  } catch {
    return 'anon';
  }
};

export default userCacheScope;
